// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__mKvL-","imageContainer":"Spinner_imageContainer__X4UFf"};